import { render, staticRenderFns } from "./decoration-document-form.vue?vue&type=template&id=4e452c2e&"
import script from "./decoration-document-form.vue?vue&type=script&lang=js&"
export * from "./decoration-document-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports